import React, { useState, useEffect } from 'react'
import {
  fetchTickerSuggestions,
  handleSearchStock,
  handleSuggestionClick,
} from '../helper/MarketsHelper'
import { formatModifiedTicker } from '../helper/StylesHelper'
import { useDebounce } from '../hooks/useDebounce' // <--- Path depends on your file structure

export default function MarketSearchBar({
  stock,
  setStock,
  isAuthenticated,
  userToken,
  navigate,
  marginVertical = '2rem',
}) {
  const [suggestions, setSuggestions] = useState([])
  const [activeMode, setActiveMode] = useState('stocks')

  // Use the custom hook to get a debounced value of `stock`.
  // We'll fetch suggestions only when `debouncedStock` changes,
  // meaning user has paused typing for our given delay (500ms here).
  const debouncedStock = useDebounce(stock, 500)

  // Whenever the user types, we simply update `stock`. The debounced
  // version (`debouncedStock`) will update 500ms later.
  const handleInputChange = (e) => {
    setStock(e.target.value)
  }

  // If `debouncedStock` or `activeMode` changes, fetch new suggestions
  useEffect(() => {
    if (!debouncedStock) {
      // If input is empty, clear suggestions
      setSuggestions([])
      return
    }

    // If we have a non-empty debounced string, fetch suggestions
    fetchTickerSuggestions(debouncedStock, setSuggestions, false, activeMode)
  }, [debouncedStock, activeMode])

  // If the user changes activeMode, also clear suggestions
  useEffect(() => {
    setSuggestions([])
  }, [activeMode])

  return (
    <div
      className="MarketsSearchWrapper"
      style={{ marginTop: marginVertical, marginBottom: marginVertical }}
    >
      <input
        id="marketsSearchBar"
        className="MarketsSearchBar bold"
        type="text"
        placeholder="Search markets"
        value={stock}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          // Let them search by pressing Enter
          handleSearchStock(
            e,
            stock,
            isAuthenticated,
            userToken,
            navigate,
            activeMode
          )
          if (e.key === 'Enter') {
            setStock('')
          }
        }}
      />

      {/** Suggestions Dropdown */}
      {suggestions.length > 0 && stock && (
        <ul className="SuggestionsDropdown">
          {suggestions.map((suggestion) => (
            <li
              key={suggestion?.ticker}
              onClick={() => {
                handleSuggestionClick(
                  suggestion?.ticker,
                  isAuthenticated,
                  userToken,
                  navigate,
                  activeMode
                )
                setStock('')
              }}
              className="SuggestionItem"
            >
              {formatModifiedTicker(suggestion?.ticker)} - {suggestion?.name}
            </li>
          ))}
        </ul>
      )}

      {/**
       * Show mode toggle buttons (stocks/crypto) if we have suggestions.
       * Otherwise, you can hide or adjust as you like.
       */}
      {suggestions.length > 0 && (
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <button
            className="CreatePostFeedButton"
            onClick={() => setActiveMode('stocks')}
            style={{
              backgroundColor:
                activeMode === 'stocks'
                  ? 'var(--stock-change-pos)'
                  : 'var(--background-color-feed-btn)',
              color: activeMode === 'stocks' ? '#000' : undefined,
            }}
          >
            Stocks
          </button>
          <button
            className="CreatePostFeedButton"
            onClick={() => setActiveMode('crypto')}
            style={{
              backgroundColor:
                activeMode === 'crypto'
                  ? 'var(--stock-change-pos)'
                  : 'var(--background-color-feed-btn)',
              color: activeMode === 'crypto' ? '#000' : undefined,
            }}
          >
            Crypto
          </button>
        </div>
      )}
    </div>
  )
}